import { WDollarParticle } from "./WDollarParticle";
import { createPortal } from "react-dom";

interface WDollarAnimation {
  id: string;
  startX: number;
  startY: number;
  endX: number;
  endY: number;
  count: number;
}

interface FlyingWDollarsProps {
  animations: WDollarAnimation[];
  onAnimationComplete: (id: string) => void;
}

export function FlyingWDollars({ animations, onAnimationComplete }: FlyingWDollarsProps) {
  const portalRoot = document.getElementById('coin-portal-root') || document.body;

  return createPortal(
    <>
      {animations.map((animation) =>
        Array.from({ length: animation.count }).map((_, index) => (
          <WDollarParticle
            key={`${animation.id}-${index}`}
            startX={animation.startX}
            startY={animation.startY}
            endX={animation.endX}
            endY={animation.endY}
            delay={index * 0.1}
            onComplete={() => {
              if (index === animation.count - 1) {
                onAnimationComplete(animation.id);
              }
            }}
          />
        ))
      )}
    </>,
    portalRoot
  );
}
